import { defineComponent as _defineComponent } from 'vue'
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { BuyBoxFilterOptions } from '@/stores/user.store';
import { jwCheckIcon } from '@/plugins/global-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

import BasicButton from '@/ui-components/BasicButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotifyMe',
  props: {
    isTitleInWatchlist: { type: Boolean, default: false },
    title: null,
    filter: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'onNotifyMe'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isTitleInWatchlist: boolean, title: TitleDetail, filter: BuyBoxFilterOptions, additionalContexts: SnowplowContext[] };





const onNotifyMe = () => {
	emit('onNotifyMe');

	let offerType = '';
	switch (props.filter) {
		case 'free':
			offerType = 'free';
			break;
		case 'cinema':
			offerType = 'cinema';
			break;
		default:
			offerType = 'streaming';
			break;
	}

	TrackingHelper.trackEvent('userinteraction', {
		action: 'notify_me_clicked',
		label: offerType,
		value: !props.isTitleInWatchlist ? 1 : 0,
	});
};

return { __sfc: true,props, emit, onNotifyMe, jwCheckIcon, faBell, BasicButton }
}

})